import {entities} from '../../api/proto';

export default class BillingHistoryItem extends entities.BillingHistoryEntry {
  constructor(item: entities.IBillingHistoryEntry, public tariff?: entities.ITariff | null) {
    super(item);
  }
}